export default __webpack_public_path__ + "static/media/icon_info-circle.701b2c39.png";